/**
 * Embedded frontend application configuration.
 *
 * Specify some settings, that could differ between customer plugin.
 */
export default {
  /**
   * This allows to hide/show Asset Management pages for public website (aka available for all visitors)
   */
  showAssetManagementPage: false,

  /**
   * This allows to hide/show Wealth pages for private website (aka available for authenticated visitors)
   */
  showWealthPage: true
}
